var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('alert-dialog'),_vm._v(" "),_c('auth-header'),_vm._v(" "),_c('v-main',[_c('nuxt')],1),_vm._v(" "),_c('default-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }